import LegacyRouteHandler from './LegacyRouteHandler';

export default LegacyRouteHandler;
